import { defineComponent as St, h as In, getCurrentInstance as Re, effectScope as er, inject as tr, onMounted as nr, onUnmounted as rr, computed as De, watch as gt, Fragment as An, isRef as ar, ref as sr, shallowRef as lr, createVNode as or, Text as ir } from "vue";
/*!
  * shared v10.0.4
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const ne = typeof window < "u";
let Z, pe;
if (process.env.NODE_ENV !== "production") {
  const e = ne && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Z = (t) => {
    e.mark(t);
  }, pe = (t, n, r) => {
    e.measure(t, n, r), e.clearMarks(n), e.clearMarks(r);
  });
}
const cr = /\{([0-9a-zA-Z]+)\}/g;
function Ke(e, ...t) {
  return t.length === 1 && F(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(cr, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const ae = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), ur = (e, t, n) => fr({ l: e, k: t, s: n }), fr = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), B = (e) => typeof e == "number" && isFinite(e), _r = (e) => yt(e) === "[object Date]", Oe = (e) => yt(e) === "[object RegExp]", Be = (e) => P(e) && Object.keys(e).length === 0, X = Object.assign;
let Ht;
const ge = () => Ht || (Ht = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Yt(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const mr = Object.prototype.hasOwnProperty;
function Ye(e, t) {
  return mr.call(e, t);
}
const W = Array.isArray, x = (e) => typeof e == "function", T = (e) => typeof e == "string", M = (e) => typeof e == "boolean", F = (e) => e !== null && typeof e == "object", dr = (e) => F(e) && x(e.then) && x(e.catch), kn = Object.prototype.toString, yt = (e) => kn.call(e), P = (e) => yt(e) === "[object Object]", Er = (e) => e == null ? "" : W(e) || P(e) && e.toString === kn ? JSON.stringify(e, null, 2) : String(e);
function Dt(e, t = "") {
  return e.reduce((n, r, a) => a === 0 ? n + r : n + t + r, "");
}
const jt = 2;
function gr(e, t = 0, n = e.length) {
  const r = e.split(/\r?\n/);
  let a = 0;
  const s = [];
  for (let l = 0; l < r.length; l++)
    if (a += r[l].length + 1, a >= t) {
      for (let i = l - jt; i <= l + jt || n > a; i++) {
        if (i < 0 || i >= r.length)
          continue;
        const u = i + 1;
        s.push(`${u}${" ".repeat(3 - String(u).length)}|  ${r[i]}`);
        const d = r[i].length;
        if (i === l) {
          const L = t - (a - d) + 1, h = Math.max(1, n > a ? d - L : n - t);
          s.push("   |  " + " ".repeat(L) + "^".repeat(h));
        } else if (i > l) {
          if (n > a) {
            const L = Math.max(Math.min(n - a, d), 1);
            s.push("   |  " + "^".repeat(L));
          }
          a += d + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function fe(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Kt = {};
function Cn(e) {
  Kt[e] || (Kt[e] = !0, fe(e));
}
function Pt() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, r) {
      const a = e.get(n);
      a && a.push(r) || e.set(n, [r]);
    },
    off(n, r) {
      const a = e.get(n);
      a && a.splice(a.indexOf(r) >>> 0, 1);
    },
    emit(n, r) {
      (e.get(n) || []).slice().map((a) => a(r)), (e.get("*") || []).slice().map((a) => a(n, r));
    }
  };
}
const We = (e) => !F(e) || W(e);
function He(e, t) {
  if (We(e) || We(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: a } = n.pop();
    Object.keys(r).forEach((s) => {
      F(r[s]) && !F(a[s]) && (a[s] = Array.isArray(r[s]) ? [] : {}), We(a[s]) || We(r[s]) ? a[s] = r[s] : n.push({ src: r[s], des: a[s] });
    });
  }
}
/*!
  * message-compiler v10.0.4
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function pr(e, t, n) {
  return { line: e, column: t, offset: n };
}
function pt(e, t, n) {
  return { start: e, end: t };
}
const D = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Nr = 17, br = {
  // tokenizer error messages
  [D.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [D.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [D.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [D.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [D.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [D.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [D.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [D.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [D.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [D.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [D.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [D.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [D.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [D.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [D.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [D.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Ae(e, t, n = {}) {
  const { domain: r, messages: a, args: s } = n, l = process.env.NODE_ENV !== "production" ? Ke((a || br)[e] || "", ...s || []) : e, i = new SyntaxError(String(l));
  return i.code = e, t && (i.location = t), i.domain = r, i;
}
function hr(e) {
  throw e;
}
const vr = /<\/?[\w\s="/.':;#-\/]+>/, Lr = (e) => vr.test(e), le = " ", Tr = "\r", Q = `
`, Or = "\u2028", Ir = "\u2029";
function Ar(e) {
  const t = e;
  let n = 0, r = 1, a = 1, s = 0;
  const l = (p) => t[p] === Tr && t[p + 1] === Q, i = (p) => t[p] === Q, u = (p) => t[p] === Ir, d = (p) => t[p] === Or, L = (p) => l(p) || i(p) || u(p) || d(p), h = () => n, g = () => r, A = () => a, y = () => s, C = (p) => l(p) || u(p) || d(p) ? Q : t[p], k = () => C(n), f = () => C(n + s);
  function _() {
    return s = 0, L(n) && (r++, a = 0), l(n) && n++, n++, a++, t[n];
  }
  function v() {
    return l(n + s) && s++, s++, t[n + s];
  }
  function E() {
    n = 0, r = 1, a = 1, s = 0;
  }
  function O(p = 0) {
    s = p;
  }
  function I() {
    const p = n + s;
    for (; p !== n; )
      _();
    s = 0;
  }
  return {
    index: h,
    line: g,
    column: A,
    peekOffset: y,
    charAt: C,
    currentChar: k,
    currentPeek: f,
    next: _,
    peek: v,
    reset: E,
    resetPeek: O,
    skipToPeek: I
  };
}
const ie = void 0, kr = ".", Bt = "'", Cr = "tokenizer";
function Sr(e, t = {}) {
  const n = t.location !== !1, r = Ar(e), a = () => r.index(), s = () => pr(r.line(), r.column(), r.index()), l = s(), i = a(), u = {
    currentType: 13,
    offset: i,
    startLoc: l,
    endLoc: l,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: l,
    lastEndLoc: l,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => u, { onError: L } = t;
  function h(o, c, N, ...S) {
    const G = d();
    if (c.column += N, c.offset += N, L) {
      const H = n ? pt(G.startLoc, c) : null, U = Ae(o, H, {
        domain: Cr,
        args: S
      });
      L(U);
    }
  }
  function g(o, c, N) {
    o.endLoc = s(), o.currentType = c;
    const S = { type: c };
    return n && (S.loc = pt(o.startLoc, o.endLoc)), N != null && (S.value = N), S;
  }
  const A = (o) => g(
    o,
    13
    /* TokenTypes.EOF */
  );
  function y(o, c) {
    return o.currentChar() === c ? (o.next(), c) : (h(D.EXPECTED_TOKEN, s(), 0, c), "");
  }
  function C(o) {
    let c = "";
    for (; o.currentPeek() === le || o.currentPeek() === Q; )
      c += o.currentPeek(), o.peek();
    return c;
  }
  function k(o) {
    const c = C(o);
    return o.skipToPeek(), c;
  }
  function f(o) {
    if (o === ie)
      return !1;
    const c = o.charCodeAt(0);
    return c >= 97 && c <= 122 || // a-z
    c >= 65 && c <= 90 || // A-Z
    c === 95;
  }
  function _(o) {
    if (o === ie)
      return !1;
    const c = o.charCodeAt(0);
    return c >= 48 && c <= 57;
  }
  function v(o, c) {
    const { currentType: N } = c;
    if (N !== 2)
      return !1;
    C(o);
    const S = f(o.currentPeek());
    return o.resetPeek(), S;
  }
  function E(o, c) {
    const { currentType: N } = c;
    if (N !== 2)
      return !1;
    C(o);
    const S = o.currentPeek() === "-" ? o.peek() : o.currentPeek(), G = _(S);
    return o.resetPeek(), G;
  }
  function O(o, c) {
    const { currentType: N } = c;
    if (N !== 2)
      return !1;
    C(o);
    const S = o.currentPeek() === Bt;
    return o.resetPeek(), S;
  }
  function I(o, c) {
    const { currentType: N } = c;
    if (N !== 7)
      return !1;
    C(o);
    const S = o.currentPeek() === ".";
    return o.resetPeek(), S;
  }
  function p(o, c) {
    const { currentType: N } = c;
    if (N !== 8)
      return !1;
    C(o);
    const S = f(o.currentPeek());
    return o.resetPeek(), S;
  }
  function R(o, c) {
    const { currentType: N } = c;
    if (!(N === 7 || N === 11))
      return !1;
    C(o);
    const S = o.currentPeek() === ":";
    return o.resetPeek(), S;
  }
  function w(o, c) {
    const { currentType: N } = c;
    if (N !== 9)
      return !1;
    const S = () => {
      const H = o.currentPeek();
      return H === "{" ? f(o.peek()) : H === "@" || H === "|" || H === ":" || H === "." || H === le || !H ? !1 : H === Q ? (o.peek(), S()) : te(o, !1);
    }, G = S();
    return o.resetPeek(), G;
  }
  function j(o) {
    C(o);
    const c = o.currentPeek() === "|";
    return o.resetPeek(), c;
  }
  function te(o, c = !0) {
    const N = (G = !1, H = "") => {
      const U = o.currentPeek();
      return U === "{" || U === "@" || !U ? G : U === "|" ? !(H === le || H === Q) : U === le ? (o.peek(), N(!0, le)) : U === Q ? (o.peek(), N(!0, Q)) : !0;
    }, S = N();
    return c && o.resetPeek(), S;
  }
  function K(o, c) {
    const N = o.currentChar();
    return N === ie ? ie : c(N) ? (o.next(), N) : null;
  }
  function he(o) {
    const c = o.charCodeAt(0);
    return c >= 97 && c <= 122 || // a-z
    c >= 65 && c <= 90 || // A-Z
    c >= 48 && c <= 57 || // 0-9
    c === 95 || // _
    c === 36;
  }
  function qe(o) {
    return K(o, he);
  }
  function ze(o) {
    const c = o.charCodeAt(0);
    return c >= 97 && c <= 122 || // a-z
    c >= 65 && c <= 90 || // A-Z
    c >= 48 && c <= 57 || // 0-9
    c === 95 || // _
    c === 36 || // $
    c === 45;
  }
  function Ze(o) {
    return K(o, ze);
  }
  function et(o) {
    const c = o.charCodeAt(0);
    return c >= 48 && c <= 57;
  }
  function tt(o) {
    return K(o, et);
  }
  function nt(o) {
    const c = o.charCodeAt(0);
    return c >= 48 && c <= 57 || // 0-9
    c >= 65 && c <= 70 || // A-F
    c >= 97 && c <= 102;
  }
  function se(o) {
    return K(o, nt);
  }
  function ke(o) {
    let c = "", N = "";
    for (; c = tt(o); )
      N += c;
    return N;
  }
  function rt(o) {
    let c = "";
    for (; ; ) {
      const N = o.currentChar();
      if (N === "{" || N === "}" || N === "@" || N === "|" || !N)
        break;
      if (N === le || N === Q)
        if (te(o))
          c += N, o.next();
        else {
          if (j(o))
            break;
          c += N, o.next();
        }
      else
        c += N, o.next();
    }
    return c;
  }
  function at(o) {
    k(o);
    let c = "", N = "";
    for (; c = Ze(o); )
      N += c;
    return o.currentChar() === ie && h(D.UNTERMINATED_CLOSING_BRACE, s(), 0), N;
  }
  function st(o) {
    k(o);
    let c = "";
    return o.currentChar() === "-" ? (o.next(), c += `-${ke(o)}`) : c += ke(o), o.currentChar() === ie && h(D.UNTERMINATED_CLOSING_BRACE, s(), 0), c;
  }
  function lt(o) {
    return o !== Bt && o !== Q;
  }
  function Wt(o) {
    k(o), y(o, "'");
    let c = "", N = "";
    for (; c = K(o, lt); )
      c === "\\" ? N += ot(o) : N += c;
    const S = o.currentChar();
    return S === Q || S === ie ? (h(D.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), S === Q && (o.next(), y(o, "'")), N) : (y(o, "'"), N);
  }
  function ot(o) {
    const c = o.currentChar();
    switch (c) {
      case "\\":
      case "'":
        return o.next(), `\\${c}`;
      case "u":
        return $e(o, c, 4);
      case "U":
        return $e(o, c, 6);
      default:
        return h(D.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, c), "";
    }
  }
  function $e(o, c, N) {
    y(o, c);
    let S = "";
    for (let G = 0; G < N; G++) {
      const H = se(o);
      if (!H) {
        h(D.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${c}${S}${o.currentChar()}`);
        break;
      }
      S += H;
    }
    return `\\${c}${S}`;
  }
  function it(o) {
    return o !== "{" && o !== "}" && o !== le && o !== Q;
  }
  function ct(o) {
    k(o);
    let c = "", N = "";
    for (; c = K(o, it); )
      N += c;
    return N;
  }
  function ut(o) {
    let c = "", N = "";
    for (; c = qe(o); )
      N += c;
    return N;
  }
  function ft(o) {
    const c = (N) => {
      const S = o.currentChar();
      return S === "{" || S === "@" || S === "|" || S === "(" || S === ")" || !S || S === le ? N : (N += S, o.next(), c(N));
    };
    return c("");
  }
  function Ce(o) {
    k(o);
    const c = y(
      o,
      "|"
      /* TokenChars.Pipe */
    );
    return k(o), c;
  }
  function Se(o, c) {
    let N = null;
    switch (o.currentChar()) {
      case "{":
        return c.braceNest >= 1 && h(D.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), o.next(), N = g(
          c,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), k(o), c.braceNest++, N;
      case "}":
        return c.braceNest > 0 && c.currentType === 2 && h(D.EMPTY_PLACEHOLDER, s(), 0), o.next(), N = g(
          c,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), c.braceNest--, c.braceNest > 0 && k(o), c.inLinked && c.braceNest === 0 && (c.inLinked = !1), N;
      case "@":
        return c.braceNest > 0 && h(D.UNTERMINATED_CLOSING_BRACE, s(), 0), N = me(o, c) || A(c), c.braceNest = 0, N;
      default: {
        let G = !0, H = !0, U = !0;
        if (j(o))
          return c.braceNest > 0 && h(D.UNTERMINATED_CLOSING_BRACE, s(), 0), N = g(c, 1, Ce(o)), c.braceNest = 0, c.inLinked = !1, N;
        if (c.braceNest > 0 && (c.currentType === 4 || c.currentType === 5 || c.currentType === 6))
          return h(D.UNTERMINATED_CLOSING_BRACE, s(), 0), c.braceNest = 0, ye(o, c);
        if (G = v(o, c))
          return N = g(c, 4, at(o)), k(o), N;
        if (H = E(o, c))
          return N = g(c, 5, st(o)), k(o), N;
        if (U = O(o, c))
          return N = g(c, 6, Wt(o)), k(o), N;
        if (!G && !H && !U)
          return N = g(c, 12, ct(o)), h(D.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, N.value), k(o), N;
        break;
      }
    }
    return N;
  }
  function me(o, c) {
    const { currentType: N } = c;
    let S = null;
    const G = o.currentChar();
    switch ((N === 7 || N === 8 || N === 11 || N === 9) && (G === Q || G === le) && h(D.INVALID_LINKED_FORMAT, s(), 0), G) {
      case "@":
        return o.next(), S = g(
          c,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), c.inLinked = !0, S;
      case ".":
        return k(o), o.next(), g(
          c,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return k(o), o.next(), g(
          c,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return j(o) ? (S = g(c, 1, Ce(o)), c.braceNest = 0, c.inLinked = !1, S) : I(o, c) || R(o, c) ? (k(o), me(o, c)) : p(o, c) ? (k(o), g(c, 11, ut(o))) : w(o, c) ? (k(o), G === "{" ? Se(o, c) || S : g(c, 10, ft(o))) : (N === 7 && h(D.INVALID_LINKED_FORMAT, s(), 0), c.braceNest = 0, c.inLinked = !1, ye(o, c));
    }
  }
  function ye(o, c) {
    let N = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (c.braceNest > 0)
      return Se(o, c) || A(c);
    if (c.inLinked)
      return me(o, c) || A(c);
    switch (o.currentChar()) {
      case "{":
        return Se(o, c) || A(c);
      case "}":
        return h(D.UNBALANCED_CLOSING_BRACE, s(), 0), o.next(), g(
          c,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return me(o, c) || A(c);
      default: {
        if (j(o))
          return N = g(c, 1, Ce(o)), c.braceNest = 0, c.inLinked = !1, N;
        if (te(o))
          return g(c, 0, rt(o));
        break;
      }
    }
    return N;
  }
  function _t() {
    const { currentType: o, offset: c, startLoc: N, endLoc: S } = u;
    return u.lastType = o, u.lastOffset = c, u.lastStartLoc = N, u.lastEndLoc = S, u.offset = a(), u.startLoc = s(), r.currentChar() === ie ? g(
      u,
      13
      /* TokenTypes.EOF */
    ) : ye(r, u);
  }
  return {
    nextToken: _t,
    currentOffset: a,
    currentPosition: s,
    context: d
  };
}
const yr = "parser", Dr = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Pr(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function Rr(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function r(f, _, v, E, ...O) {
    const I = f.currentPosition();
    if (I.offset += E, I.column += E, n) {
      const p = t ? pt(v, I) : null, R = Ae(_, p, {
        domain: yr,
        args: O
      });
      n(R);
    }
  }
  function a(f, _, v) {
    const E = { type: f };
    return t && (E.start = _, E.end = _, E.loc = { start: v, end: v }), E;
  }
  function s(f, _, v, E) {
    t && (f.end = _, f.loc && (f.loc.end = v));
  }
  function l(f, _) {
    const v = f.context(), E = a(3, v.offset, v.startLoc);
    return E.value = _, s(E, f.currentOffset(), f.currentPosition()), E;
  }
  function i(f, _) {
    const v = f.context(), { lastOffset: E, lastStartLoc: O } = v, I = a(5, E, O);
    return I.index = parseInt(_, 10), f.nextToken(), s(I, f.currentOffset(), f.currentPosition()), I;
  }
  function u(f, _) {
    const v = f.context(), { lastOffset: E, lastStartLoc: O } = v, I = a(4, E, O);
    return I.key = _, f.nextToken(), s(I, f.currentOffset(), f.currentPosition()), I;
  }
  function d(f, _) {
    const v = f.context(), { lastOffset: E, lastStartLoc: O } = v, I = a(9, E, O);
    return I.value = _.replace(Dr, Pr), f.nextToken(), s(I, f.currentOffset(), f.currentPosition()), I;
  }
  function L(f) {
    const _ = f.nextToken(), v = f.context(), { lastOffset: E, lastStartLoc: O } = v, I = a(8, E, O);
    return _.type !== 11 ? (r(f, D.UNEXPECTED_EMPTY_LINKED_MODIFIER, v.lastStartLoc, 0), I.value = "", s(I, E, O), {
      nextConsumeToken: _,
      node: I
    }) : (_.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, re(_)), I.value = _.value || "", s(I, f.currentOffset(), f.currentPosition()), {
      node: I
    });
  }
  function h(f, _) {
    const v = f.context(), E = a(7, v.offset, v.startLoc);
    return E.value = _, s(E, f.currentOffset(), f.currentPosition()), E;
  }
  function g(f) {
    const _ = f.context(), v = a(6, _.offset, _.startLoc);
    let E = f.nextToken();
    if (E.type === 8) {
      const O = L(f);
      v.modifier = O.node, E = O.nextConsumeToken || f.nextToken();
    }
    switch (E.type !== 9 && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(E)), E = f.nextToken(), E.type === 2 && (E = f.nextToken()), E.type) {
      case 10:
        E.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(E)), v.key = h(f, E.value || "");
        break;
      case 4:
        E.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(E)), v.key = u(f, E.value || "");
        break;
      case 5:
        E.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(E)), v.key = i(f, E.value || "");
        break;
      case 6:
        E.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(E)), v.key = d(f, E.value || "");
        break;
      default: {
        r(f, D.UNEXPECTED_EMPTY_LINKED_KEY, _.lastStartLoc, 0);
        const O = f.context(), I = a(7, O.offset, O.startLoc);
        return I.value = "", s(I, O.offset, O.startLoc), v.key = I, s(v, O.offset, O.startLoc), {
          nextConsumeToken: E,
          node: v
        };
      }
    }
    return s(v, f.currentOffset(), f.currentPosition()), {
      node: v
    };
  }
  function A(f) {
    const _ = f.context(), v = _.currentType === 1 ? f.currentOffset() : _.offset, E = _.currentType === 1 ? _.endLoc : _.startLoc, O = a(2, v, E);
    O.items = [];
    let I = null;
    do {
      const w = I || f.nextToken();
      switch (I = null, w.type) {
        case 0:
          w.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(w)), O.items.push(l(f, w.value || ""));
          break;
        case 5:
          w.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(w)), O.items.push(i(f, w.value || ""));
          break;
        case 4:
          w.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(w)), O.items.push(u(f, w.value || ""));
          break;
        case 6:
          w.value == null && r(f, D.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, re(w)), O.items.push(d(f, w.value || ""));
          break;
        case 7: {
          const j = g(f);
          O.items.push(j.node), I = j.nextConsumeToken || null;
          break;
        }
      }
    } while (_.currentType !== 13 && _.currentType !== 1);
    const p = _.currentType === 1 ? _.lastOffset : f.currentOffset(), R = _.currentType === 1 ? _.lastEndLoc : f.currentPosition();
    return s(O, p, R), O;
  }
  function y(f, _, v, E) {
    const O = f.context();
    let I = E.items.length === 0;
    const p = a(1, _, v);
    p.cases = [], p.cases.push(E);
    do {
      const R = A(f);
      I || (I = R.items.length === 0), p.cases.push(R);
    } while (O.currentType !== 13);
    return I && r(f, D.MUST_HAVE_MESSAGES_IN_PLURAL, v, 0), s(p, f.currentOffset(), f.currentPosition()), p;
  }
  function C(f) {
    const _ = f.context(), { offset: v, startLoc: E } = _, O = A(f);
    return _.currentType === 13 ? O : y(f, v, E, O);
  }
  function k(f) {
    const _ = Sr(f, X({}, e)), v = _.context(), E = a(0, v.offset, v.startLoc);
    return t && E.loc && (E.loc.source = f), E.body = C(_), e.onCacheKey && (E.cacheKey = e.onCacheKey(f)), v.currentType !== 13 && r(_, D.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, f[v.offset] || ""), s(E, _.currentOffset(), _.currentPosition()), E;
  }
  return { parse: k };
}
function re(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Fr(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (s) => (n.helpers.add(s), s) };
}
function Xt(e, t) {
  for (let n = 0; n < e.length; n++)
    Rt(e[n], t);
}
function Rt(e, t) {
  switch (e.type) {
    case 1:
      Xt(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Xt(e.items, t);
      break;
    case 6: {
      Rt(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Mr(e, t = {}) {
  const n = Fr(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Rt(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function Ur(e) {
  const t = e.body;
  return t.type === 2 ? Jt(t) : t.cases.forEach((n) => Jt(n)), e;
}
function Jt(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = Dt(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const wr = "minifier";
function Te(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Te(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let r = 0; r < n.length; r++)
        Te(n[r]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let r = 0; r < n.length; r++)
        Te(n[r]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Te(t.key), t.k = t.key, delete t.key, t.modifier && (Te(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw Ae(D.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: wr,
          args: [e.type]
        });
  }
  delete e.type;
}
const Vr = "parser";
function $r(e, t) {
  const { sourceMap: n, filename: r, breakLineCode: a, needIndent: s } = t, l = t.location !== !1, i = {
    filename: r,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: s,
    indentLevel: 0
  };
  l && e.loc && (i.source = e.loc.source);
  const u = () => i;
  function d(k, f) {
    i.code += k;
  }
  function L(k, f = !0) {
    const _ = f ? a : "";
    d(s ? _ + "  ".repeat(k) : _);
  }
  function h(k = !0) {
    const f = ++i.indentLevel;
    k && L(f);
  }
  function g(k = !0) {
    const f = --i.indentLevel;
    k && L(f);
  }
  function A() {
    L(i.indentLevel);
  }
  return {
    context: u,
    push: d,
    indent: h,
    deindent: g,
    newline: A,
    helper: (k) => `_${k}`,
    needIndent: () => i.needIndent
  };
}
function xr(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Ie(e, t.key), t.modifier ? (e.push(", "), Ie(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Wr(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const a = t.items.length;
  for (let s = 0; s < a && (Ie(e, t.items[s]), s !== a - 1); s++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function Gr(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const a = t.cases.length;
    for (let s = 0; s < a && (Ie(e, t.cases[s]), s !== a - 1); s++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function Hr(e, t) {
  t.body ? Ie(e, t.body) : e.push("null");
}
function Ie(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Hr(e, t);
      break;
    case 1:
      Gr(e, t);
      break;
    case 2:
      Wr(e, t);
      break;
    case 6:
      xr(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw Ae(D.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Vr,
          args: [t.type]
        });
  }
}
const Yr = (e, t = {}) => {
  const n = T(t.mode) ? t.mode : "normal", r = T(t.filename) ? t.filename : "message.intl", a = !!t.sourceMap, s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, l = t.needIndent ? t.needIndent : n !== "arrow", i = e.helpers || [], u = $r(e, {
    mode: n,
    filename: r,
    sourceMap: a,
    breakLineCode: s,
    needIndent: l
  });
  u.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), u.indent(l), i.length > 0 && (u.push(`const { ${Dt(i.map((h) => `${h}: _${h}`), ", ")} } = ctx`), u.newline()), u.push("return "), Ie(u, e), u.deindent(l), u.push("}"), delete e.helpers;
  const { code: d, map: L } = u.context();
  return {
    ast: e,
    code: d,
    map: L ? L.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function jr(e, t = {}) {
  const n = X({}, t), r = !!n.jit, a = !!n.minify, s = n.optimize == null ? !0 : n.optimize, i = Rr(n).parse(e);
  return r ? (s && Ur(i), a && Te(i), { ast: i, code: "" }) : (Mr(i, n), Yr(i, n));
}
/*!
  * core-base v10.0.4
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function Kr() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (ge().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (ge().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function mt(e) {
  return (n) => Br(n, e);
}
function Br(e, t) {
  const n = t.b || t.body;
  if ((n.t || n.type) === 1) {
    const r = n, a = r.c || r.cases;
    return e.plural(a.reduce((s, l) => [
      ...s,
      Qt(e, l)
    ], []));
  } else
    return Qt(e, n);
}
function Qt(e, t) {
  const n = t.s || t.static;
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = (t.i || t.items).reduce((a, s) => [...a, Nt(e, s)], []);
    return e.normalize(r);
  }
}
function Nt(e, t) {
  const n = t.t || t.type;
  switch (n) {
    case 3: {
      const r = t;
      return r.v || r.value;
    }
    case 9: {
      const r = t;
      return r.v || r.value;
    }
    case 4: {
      const r = t;
      return e.interpolate(e.named(r.k || r.key));
    }
    case 5: {
      const r = t;
      return e.interpolate(e.list(r.i != null ? r.i : r.index));
    }
    case 6: {
      const r = t, a = r.m || r.modifier;
      return e.linked(Nt(e, r.k || r.key), a ? Nt(e, a) : void 0, e.type);
    }
    case 7: {
      const r = t;
      return r.v || r.value;
    }
    case 8: {
      const r = t;
      return r.v || r.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const Xr = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Jr(e, t) {
  t && Lr(e) && fe(Ke(Xr, { source: e }));
}
const Qr = (e) => e;
let Ge = /* @__PURE__ */ Object.create(null);
const ue = (e) => F(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function qr(e, t = {}) {
  let n = !1;
  const r = t.onError || hr;
  return t.onError = (a) => {
    n = !0, r(a);
  }, { ...jr(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function zr(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && T(e)) {
    const n = M(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Jr(e, n);
    const a = (t.onCacheKey || Qr)(e), s = Ge[a];
    if (s)
      return s;
    const { ast: l, detectError: i } = qr(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), u = mt(l);
    return i ? u : Ge[a] = u;
  } else {
    if (process.env.NODE_ENV !== "production" && !ue(e))
      return fe(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const r = Ge[n];
      return r || (Ge[n] = mt(e));
    } else
      return mt(e);
  }
}
let Fe = null;
function Zr(e) {
  Fe = e;
}
function ea(e, t, n) {
  Fe && Fe.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const ta = /* @__PURE__ */ na("function:translate");
function na(e) {
  return (t) => Fe && Fe.emit(e, t);
}
const J = {
  INVALID_ARGUMENT: Nr,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, ra = 24;
function oe(e) {
  return Ae(e, null, process.env.NODE_ENV !== "production" ? { messages: aa } : void 0);
}
const aa = {
  [J.INVALID_ARGUMENT]: "Invalid arguments",
  [J.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [J.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [J.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [J.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [J.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [J.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Ft(e, t) {
  return t.locale != null ? qt(t.locale) : qt(e.locale);
}
let dt;
function qt(e) {
  if (T(e))
    return e;
  if (x(e)) {
    if (e.resolvedOnce && dt != null)
      return dt;
    if (e.constructor.name === "Function") {
      const t = e();
      if (dr(t))
        throw oe(J.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return dt = t;
    } else
      throw oe(J.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw oe(J.NOT_SUPPORT_LOCALE_TYPE);
}
function sa(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...W(t) ? t : F(t) ? Object.keys(t) : T(t) ? [t] : [n]
  ])];
}
function Sn(e, t, n) {
  const r = T(n) ? n : Me, a = e;
  a.__localeChainCache || (a.__localeChainCache = /* @__PURE__ */ new Map());
  let s = a.__localeChainCache.get(r);
  if (!s) {
    s = [];
    let l = [n];
    for (; W(l); )
      l = zt(s, l, t);
    const i = W(t) || !P(t) ? t : t.default ? t.default : null;
    l = T(i) ? [i] : i, W(l) && zt(s, l, !1), a.__localeChainCache.set(r, s);
  }
  return s;
}
function zt(e, t, n) {
  let r = !0;
  for (let a = 0; a < t.length && M(r); a++) {
    const s = t[a];
    T(s) && (r = la(e, t[a], n));
  }
  return r;
}
function la(e, t, n) {
  let r;
  const a = t.split("-");
  do {
    const s = a.join("-");
    r = oa(e, s, n), a.splice(-1, 1);
  } while (a.length && r === !0);
  return r;
}
function oa(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const a = t.replace(/!/g, "");
    e.push(a), (W(n) || P(n)) && n[a] && (r = n[a]);
  }
  return r;
}
const _e = [];
_e[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
_e[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
_e[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
_e[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
_e[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
_e[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
_e[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const ia = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function ca(e) {
  return ia.test(e);
}
function ua(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function fa(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function _a(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : ca(t) ? ua(t) : "*" + t;
}
function ma(e) {
  const t = [];
  let n = -1, r = 0, a = 0, s, l, i, u, d, L, h;
  const g = [];
  g[
    0
    /* Actions.APPEND */
  ] = () => {
    l === void 0 ? l = i : l += i;
  }, g[
    1
    /* Actions.PUSH */
  ] = () => {
    l !== void 0 && (t.push(l), l = void 0);
  }, g[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    g[
      0
      /* Actions.APPEND */
    ](), a++;
  }, g[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (a > 0)
      a--, r = 4, g[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (a = 0, l === void 0 || (l = _a(l), l === !1))
        return !1;
      g[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function A() {
    const y = e[n + 1];
    if (r === 5 && y === "'" || r === 6 && y === '"')
      return n++, i = "\\" + y, g[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, s = e[n], !(s === "\\" && A())) {
      if (u = fa(s), h = _e[r], d = h[u] || h.l || 8, d === 8 || (r = d[0], d[1] !== void 0 && (L = g[d[1]], L && (i = s, L() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const Zt = /* @__PURE__ */ new Map();
function da(e, t) {
  return F(e) ? e[t] : null;
}
function Ea(e, t) {
  if (!F(e))
    return null;
  let n = Zt.get(t);
  if (n || (n = ma(t), n && Zt.set(t, n)), !n)
    return null;
  const r = n.length;
  let a = e, s = 0;
  for (; s < r; ) {
    const l = a[n[s]];
    if (l === void 0 || x(a))
      return null;
    a = l, s++;
  }
  return a;
}
const z = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, ga = 8, pa = {
  [z.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [z.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [z.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [z.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [z.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [z.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [z.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Ne(e, ...t) {
  return Ke(pa[e], ...t);
}
const Na = "10.0.4", Xe = -1, Me = "en-US", je = "", en = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function ba() {
  return {
    upper: (e, t) => t === "text" && T(e) ? e.toUpperCase() : t === "vnode" && F(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && T(e) ? e.toLowerCase() : t === "vnode" && F(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && T(e) ? en(e) : t === "vnode" && F(e) && "__v_isVNode" in e ? en(e.children) : e
  };
}
let yn;
function ha(e) {
  yn = e;
}
let Dn;
function va(e) {
  Dn = e;
}
let Pn;
function La(e) {
  Pn = e;
}
let Rn = null;
const Ta = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Rn = e;
}, Oa = /* @__NO_SIDE_EFFECTS__ */ () => Rn;
let Fn = null;
const tn = (e) => {
  Fn = e;
}, Ia = () => Fn;
let nn = 0;
function Aa(e = {}) {
  const t = x(e.onWarn) ? e.onWarn : fe, n = T(e.version) ? e.version : Na, r = T(e.locale) || x(e.locale) ? e.locale : Me, a = x(r) ? Me : r, s = W(e.fallbackLocale) || P(e.fallbackLocale) || T(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : a, l = P(e.messages) ? e.messages : { [a]: {} }, i = P(e.datetimeFormats) ? e.datetimeFormats : { [a]: {} }, u = P(e.numberFormats) ? e.numberFormats : { [a]: {} }, d = X({}, e.modifiers || {}, ba()), L = e.pluralRules || {}, h = x(e.missing) ? e.missing : null, g = M(e.missingWarn) || Oe(e.missingWarn) ? e.missingWarn : !0, A = M(e.fallbackWarn) || Oe(e.fallbackWarn) ? e.fallbackWarn : !0, y = !!e.fallbackFormat, C = !!e.unresolving, k = x(e.postTranslation) ? e.postTranslation : null, f = P(e.processor) ? e.processor : null, _ = M(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, v = !!e.escapeParameter, E = x(e.messageCompiler) ? e.messageCompiler : yn;
  process.env.NODE_ENV !== "production" && x(e.messageCompiler) && Cn(Ne(z.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const O = x(e.messageResolver) ? e.messageResolver : Dn || da, I = x(e.localeFallbacker) ? e.localeFallbacker : Pn || sa, p = F(e.fallbackContext) ? e.fallbackContext : void 0, R = e, w = F(R.__datetimeFormatters) ? R.__datetimeFormatters : /* @__PURE__ */ new Map(), j = F(R.__numberFormatters) ? R.__numberFormatters : /* @__PURE__ */ new Map(), te = F(R.__meta) ? R.__meta : {};
  nn++;
  const K = {
    version: n,
    cid: nn,
    locale: r,
    fallbackLocale: s,
    messages: l,
    modifiers: d,
    pluralRules: L,
    missing: h,
    missingWarn: g,
    fallbackWarn: A,
    fallbackFormat: y,
    unresolving: C,
    postTranslation: k,
    processor: f,
    warnHtmlMessage: _,
    escapeParameter: v,
    messageCompiler: E,
    messageResolver: O,
    localeFallbacker: I,
    fallbackContext: p,
    onWarn: t,
    __meta: te
  };
  return K.datetimeFormats = i, K.numberFormats = u, K.__datetimeFormatters = w, K.__numberFormatters = j, process.env.NODE_ENV !== "production" && (K.__v_emitter = R.__v_emitter != null ? R.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && ea(K, n, te), K;
}
function Je(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Mn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Mt(e, t, n, r, a) {
  const { missing: s, onWarn: l } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: a,
      groupId: `${a}:${t}`
    });
  }
  if (s !== null) {
    const i = s(e, n, t, a);
    return T(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Mn(r, t) && l(Ne(z.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Pe(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Un(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function ka(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (Un(e, t[r]))
      return !0;
  return !1;
}
const rn = typeof Intl < "u", wn = {
  dateTimeFormat: rn && typeof Intl.DateTimeFormat < "u",
  numberFormat: rn && typeof Intl.NumberFormat < "u"
};
function an(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: a, onWarn: s, localeFallbacker: l } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !wn.dateTimeFormat)
    return s(Ne(z.CANNOT_FORMAT_DATE)), je;
  const [u, d, L, h] = bt(...t), g = M(L.missingWarn) ? L.missingWarn : e.missingWarn, A = M(L.fallbackWarn) ? L.fallbackWarn : e.fallbackWarn, y = !!L.part, C = Ft(e, L), k = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    C
  );
  if (!T(u) || u === "")
    return new Intl.DateTimeFormat(C, h).format(d);
  let f = {}, _, v = null, E = C, O = null;
  const I = "datetime format";
  for (let w = 0; w < k.length; w++) {
    if (_ = O = k[w], process.env.NODE_ENV !== "production" && C !== _ && Je(A, u) && s(Ne(z.FALLBACK_TO_DATE_FORMAT, {
      key: u,
      target: _
    })), process.env.NODE_ENV !== "production" && C !== _) {
      const j = e.__v_emitter;
      j && j.emit("fallback", {
        type: I,
        key: u,
        from: E,
        to: O,
        groupId: `${I}:${u}`
      });
    }
    if (f = n[_] || {}, v = f[u], P(v))
      break;
    Mt(e, u, _, g, I), E = O;
  }
  if (!P(v) || !T(_))
    return r ? Xe : u;
  let p = `${_}__${u}`;
  Be(h) || (p = `${p}__${JSON.stringify(h)}`);
  let R = i.get(p);
  return R || (R = new Intl.DateTimeFormat(_, X({}, v, h)), i.set(p, R)), y ? R.formatToParts(d) : R.format(d);
}
const Vn = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function bt(...e) {
  const [t, n, r, a] = e, s = {};
  let l = {}, i;
  if (T(t)) {
    const u = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!u)
      throw oe(J.INVALID_ISO_DATE_ARGUMENT);
    const d = u[3] ? u[3].trim().startsWith("T") ? `${u[1].trim()}${u[3].trim()}` : `${u[1].trim()}T${u[3].trim()}` : u[1].trim();
    i = new Date(d);
    try {
      i.toISOString();
    } catch {
      throw oe(J.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (_r(t)) {
    if (isNaN(t.getTime()))
      throw oe(J.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (B(t))
    i = t;
  else
    throw oe(J.INVALID_ARGUMENT);
  return T(n) ? s.key = n : P(n) && Object.keys(n).forEach((u) => {
    Vn.includes(u) ? l[u] = n[u] : s[u] = n[u];
  }), T(r) ? s.locale = r : P(r) && (l = r), P(a) && (l = a), [s.key || "", i, s, l];
}
function sn(e, t, n) {
  const r = e;
  for (const a in n) {
    const s = `${t}__${a}`;
    r.__datetimeFormatters.has(s) && r.__datetimeFormatters.delete(s);
  }
}
function ln(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: a, onWarn: s, localeFallbacker: l } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !wn.numberFormat)
    return s(Ne(z.CANNOT_FORMAT_NUMBER)), je;
  const [u, d, L, h] = ht(...t), g = M(L.missingWarn) ? L.missingWarn : e.missingWarn, A = M(L.fallbackWarn) ? L.fallbackWarn : e.fallbackWarn, y = !!L.part, C = Ft(e, L), k = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    C
  );
  if (!T(u) || u === "")
    return new Intl.NumberFormat(C, h).format(d);
  let f = {}, _, v = null, E = C, O = null;
  const I = "number format";
  for (let w = 0; w < k.length; w++) {
    if (_ = O = k[w], process.env.NODE_ENV !== "production" && C !== _ && Je(A, u) && s(Ne(z.FALLBACK_TO_NUMBER_FORMAT, {
      key: u,
      target: _
    })), process.env.NODE_ENV !== "production" && C !== _) {
      const j = e.__v_emitter;
      j && j.emit("fallback", {
        type: I,
        key: u,
        from: E,
        to: O,
        groupId: `${I}:${u}`
      });
    }
    if (f = n[_] || {}, v = f[u], P(v))
      break;
    Mt(e, u, _, g, I), E = O;
  }
  if (!P(v) || !T(_))
    return r ? Xe : u;
  let p = `${_}__${u}`;
  Be(h) || (p = `${p}__${JSON.stringify(h)}`);
  let R = i.get(p);
  return R || (R = new Intl.NumberFormat(_, X({}, v, h)), i.set(p, R)), y ? R.formatToParts(d) : R.format(d);
}
const $n = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function ht(...e) {
  const [t, n, r, a] = e, s = {};
  let l = {};
  if (!B(t))
    throw oe(J.INVALID_ARGUMENT);
  const i = t;
  return T(n) ? s.key = n : P(n) && Object.keys(n).forEach((u) => {
    $n.includes(u) ? l[u] = n[u] : s[u] = n[u];
  }), T(r) ? s.locale = r : P(r) && (l = r), P(a) && (l = a), [s.key || "", i, s, l];
}
function on(e, t, n) {
  const r = e;
  for (const a in n) {
    const s = `${t}__${a}`;
    r.__numberFormatters.has(s) && r.__numberFormatters.delete(s);
  }
}
const Ca = (e) => e, Sa = (e) => "", ya = "text", Da = (e) => e.length === 0 ? "" : Dt(e), Pa = Er;
function cn(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Ra(e) {
  const t = B(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (B(e.named.count) || B(e.named.n)) ? B(e.named.count) ? e.named.count : B(e.named.n) ? e.named.n : t : t;
}
function Fa(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Ma(e = {}) {
  const t = e.locale, n = Ra(e), r = F(e.pluralRules) && T(t) && x(e.pluralRules[t]) ? e.pluralRules[t] : cn, a = F(e.pluralRules) && T(t) && x(e.pluralRules[t]) ? cn : void 0, s = (f) => f[r(n, f.length, a)], l = e.list || [], i = (f) => l[f], u = e.named || {};
  B(e.pluralIndex) && Fa(n, u);
  const d = (f) => u[f];
  function L(f, _) {
    const v = x(e.messages) ? e.messages(f, !!_) : F(e.messages) ? e.messages[f] : !1;
    return v || (e.parent ? e.parent.message(f) : Sa);
  }
  const h = (f) => e.modifiers ? e.modifiers[f] : Ca, g = P(e.processor) && x(e.processor.normalize) ? e.processor.normalize : Da, A = P(e.processor) && x(e.processor.interpolate) ? e.processor.interpolate : Pa, y = P(e.processor) && T(e.processor.type) ? e.processor.type : ya, k = {
    list: i,
    named: d,
    plural: s,
    linked: (f, ..._) => {
      const [v, E] = _;
      let O = "text", I = "";
      _.length === 1 ? F(v) ? (I = v.modifier || I, O = v.type || O) : T(v) && (I = v || I) : _.length === 2 && (T(v) && (I = v || I), T(E) && (O = E || O));
      const p = L(f, !0)(k), R = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        O === "vnode" && W(p) && I ? p[0] : p
      );
      return I ? h(I)(R, O) : R;
    },
    message: L,
    type: y,
    interpolate: A,
    normalize: g,
    values: X({}, l, u)
  };
  return k;
}
const un = () => "", ee = (e) => x(e);
function fn(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: a, messageCompiler: s, fallbackLocale: l, messages: i } = e, [u, d] = vt(...t), L = M(d.missingWarn) ? d.missingWarn : e.missingWarn, h = M(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, g = M(d.escapeParameter) ? d.escapeParameter : e.escapeParameter, A = !!d.resolvedMessage, y = T(d.default) || M(d.default) ? M(d.default) ? s ? u : () => u : d.default : n ? s ? u : () => u : null, C = n || y != null && (T(y) || x(y)), k = Ft(e, d);
  g && Ua(d);
  let [f, _, v] = A ? [
    u,
    k,
    i[k] || {}
  ] : xn(e, u, k, l, h, L), E = f, O = u;
  if (!A && !(T(E) || ue(E) || ee(E)) && C && (E = y, O = E), !A && (!(T(E) || ue(E) || ee(E)) || !T(_)))
    return a ? Xe : u;
  if (process.env.NODE_ENV !== "production" && T(E) && e.messageCompiler == null)
    return fe(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${u}'.`), u;
  let I = !1;
  const p = () => {
    I = !0;
  }, R = ee(E) ? E : Wn(e, u, _, E, O, p);
  if (I)
    return E;
  const w = xa(e, _, v, d), j = Ma(w), te = wa(e, R, j), K = r ? r(te, u) : te;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const he = {
      timestamp: Date.now(),
      key: T(u) ? u : ee(E) ? E.key : "",
      locale: _ || (ee(E) ? E.locale : ""),
      format: T(E) ? E : ee(E) ? E.source : "",
      message: K
    };
    he.meta = X({}, e.__meta, /* @__PURE__ */ Oa() || {}), ta(he);
  }
  return K;
}
function Ua(e) {
  W(e.list) ? e.list = e.list.map((t) => T(t) ? Yt(t) : t) : F(e.named) && Object.keys(e.named).forEach((t) => {
    T(e.named[t]) && (e.named[t] = Yt(e.named[t]));
  });
}
function xn(e, t, n, r, a, s) {
  const { messages: l, onWarn: i, messageResolver: u, localeFallbacker: d } = e, L = d(e, r, n);
  let h = {}, g, A = null, y = n, C = null;
  const k = "translate";
  for (let f = 0; f < L.length; f++) {
    if (g = C = L[f], process.env.NODE_ENV !== "production" && n !== g && !Un(n, g) && Je(a, t) && i(Ne(z.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: g
    })), process.env.NODE_ENV !== "production" && n !== g) {
      const O = e.__v_emitter;
      O && O.emit("fallback", {
        type: k,
        key: t,
        from: y,
        to: C,
        groupId: `${k}:${t}`
      });
    }
    h = l[g] || {};
    let _ = null, v, E;
    if (process.env.NODE_ENV !== "production" && ne && (_ = window.performance.now(), v = "intlify-message-resolve-start", E = "intlify-message-resolve-end", Z && Z(v)), (A = u(h, t)) === null && (A = h[t]), process.env.NODE_ENV !== "production" && ne) {
      const O = window.performance.now(), I = e.__v_emitter;
      I && _ && A && I.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: A,
        time: O - _,
        groupId: `${k}:${t}`
      }), v && E && Z && pe && (Z(E), pe("intlify message resolve", v, E));
    }
    if (T(A) || ue(A) || ee(A))
      break;
    if (!ka(g, L)) {
      const O = Mt(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        g,
        s,
        k
      );
      O !== t && (A = O);
    }
    y = C;
  }
  return [A, g, h];
}
function Wn(e, t, n, r, a, s) {
  const { messageCompiler: l, warnHtmlMessage: i } = e;
  if (ee(r)) {
    const g = r;
    return g.locale = g.locale || n, g.key = g.key || t, g;
  }
  if (l == null) {
    const g = () => r;
    return g.locale = n, g.key = t, g;
  }
  let u = null, d, L;
  process.env.NODE_ENV !== "production" && ne && (u = window.performance.now(), d = "intlify-message-compilation-start", L = "intlify-message-compilation-end", Z && Z(d));
  const h = l(r, Va(e, n, a, r, i, s));
  if (process.env.NODE_ENV !== "production" && ne) {
    const g = window.performance.now(), A = e.__v_emitter;
    A && u && A.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: g - u,
      groupId: `translate:${t}`
    }), d && L && Z && pe && (Z(L), pe("intlify message compilation", d, L));
  }
  return h.locale = n, h.key = t, h.source = r, h;
}
function wa(e, t, n) {
  let r = null, a, s;
  process.env.NODE_ENV !== "production" && ne && (r = window.performance.now(), a = "intlify-message-evaluation-start", s = "intlify-message-evaluation-end", Z && Z(a));
  const l = t(n);
  if (process.env.NODE_ENV !== "production" && ne) {
    const i = window.performance.now(), u = e.__v_emitter;
    u && r && u.emit("message-evaluation", {
      type: "message-evaluation",
      value: l,
      time: i - r,
      groupId: `translate:${t.key}`
    }), a && s && Z && pe && (Z(s), pe("intlify message evaluation", a, s));
  }
  return l;
}
function vt(...e) {
  const [t, n, r] = e, a = {};
  if (!T(t) && !B(t) && !ee(t) && !ue(t))
    throw oe(J.INVALID_ARGUMENT);
  const s = B(t) ? String(t) : (ee(t), t);
  return B(n) ? a.plural = n : T(n) ? a.default = n : P(n) && !Be(n) ? a.named = n : W(n) && (a.list = n), B(r) ? a.plural = r : T(r) ? a.default = r : P(r) && X(a, r), [s, a];
}
function Va(e, t, n, r, a, s) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: a,
    onError: (l) => {
      if (s && s(l), process.env.NODE_ENV !== "production") {
        const i = $a(r), u = `Message compilation error: ${l.message}`, d = l.location && i && gr(i, l.location.start.offset, l.location.end.offset), L = e.__v_emitter;
        L && i && L.emit("compile-error", {
          message: i,
          error: l.message,
          start: l.location && l.location.start.offset,
          end: l.location && l.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(d ? `${u}
${d}` : u);
      } else
        throw l;
    },
    onCacheKey: (l) => ur(t, n, l)
  };
}
function $a(e) {
  if (T(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function xa(e, t, n, r) {
  const { modifiers: a, pluralRules: s, messageResolver: l, fallbackLocale: i, fallbackWarn: u, missingWarn: d, fallbackContext: L } = e, g = {
    locale: t,
    modifiers: a,
    pluralRules: s,
    messages: (A, y) => {
      let C = l(n, A);
      if (C == null && (L || y)) {
        const [, , k] = xn(
          L || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          A,
          t,
          i,
          u,
          d
        );
        C = l(k, A);
      }
      if (T(C) || ue(C)) {
        let k = !1;
        const _ = Wn(e, A, t, C, A, () => {
          k = !0;
        });
        return k ? un : _;
      } else return ee(C) ? C : un;
    }
  };
  return e.processor && (g.processor = e.processor), r.list && (g.list = r.list), r.named && (g.named = r.named), B(r.plural) && (g.pluralIndex = r.plural), g;
}
Kr();
function Wa() {
  return Gn().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Gn() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const Ga = typeof Proxy == "function", Ha = "devtools-plugin:setup", Ya = "plugin:settings:set";
let Le, Lt;
function ja() {
  var e;
  return Le !== void 0 || (typeof window < "u" && window.performance ? (Le = !0, Lt = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Le = !0, Lt = globalThis.perf_hooks.performance) : Le = !1), Le;
}
function Ka() {
  return ja() ? Lt.now() : Date.now();
}
class Ba {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const r = {};
    if (t.settings)
      for (const l in t.settings) {
        const i = t.settings[l];
        r[l] = i.defaultValue;
      }
    const a = `__vue-devtools-plugin-settings__${t.id}`;
    let s = Object.assign({}, r);
    try {
      const l = localStorage.getItem(a), i = JSON.parse(l);
      Object.assign(s, i);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return s;
      },
      setSettings(l) {
        try {
          localStorage.setItem(a, JSON.stringify(l));
        } catch {
        }
        s = l;
      },
      now() {
        return Ka();
      }
    }, n && n.on(Ya, (l, i) => {
      l === this.plugin.id && this.fallbacks.setSettings(i);
    }), this.proxiedOn = new Proxy({}, {
      get: (l, i) => this.target ? this.target.on[i] : (...u) => {
        this.onQueue.push({
          method: i,
          args: u
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (l, i) => this.target ? this.target[i] : i === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(i) ? (...u) => (this.targetQueue.push({
        method: i,
        args: u,
        resolve: () => {
        }
      }), this.fallbacks[i](...u)) : (...u) => new Promise((d) => {
        this.targetQueue.push({
          method: i,
          args: u,
          resolve: d
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function Xa(e, t) {
  const n = e, r = Gn(), a = Wa(), s = Ga && n.enableEarlyProxy;
  if (a && (r.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !s))
    a.emit(Ha, e, t);
  else {
    const l = s ? new Ba(n, a) : null;
    (r.__VUE_DEVTOOLS_PLUGINS__ = r.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: l
    }), l && t(l.proxiedTarget);
  }
}
/*!
  * vue-i18n v10.0.4
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ja = "10.0.4";
function Qa() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (ge().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (ge().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (ge().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (ge().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const ce = {
  FALLBACK_TO_ROOT: ga,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  DEPRECATE_TC: 11
}, qa = {
  [ce.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [ce.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [ce.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [ce.DEPRECATE_TC]: "'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc’ are going to remove in v11."
};
function Qe(e, ...t) {
  return Ke(qa[e], ...t);
}
const $ = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: ra,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function q(e, ...t) {
  return Ae(e, null, process.env.NODE_ENV !== "production" ? { messages: za, args: t } : void 0);
}
const za = {
  [$.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [$.INVALID_ARGUMENT]: "Invalid argument",
  [$.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [$.NOT_INSTALLED]: "Need to install with `app.use` function",
  [$.UNEXPECTED_ERROR]: "Unexpected error",
  [$.REQUIRED_VALUE]: "Required in value: {0}",
  [$.INVALID_VALUE]: "Invalid value",
  [$.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [$.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [$.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [$.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Tt = /* @__PURE__ */ ae("__translateVNode"), Ot = /* @__PURE__ */ ae("__datetimeParts"), It = /* @__PURE__ */ ae("__numberParts"), be = /* @__PURE__ */ ae("__enableEmitter"), Ue = /* @__PURE__ */ ae("__disableEmitter"), Hn = ae("__setPluralRules"), Yn = /* @__PURE__ */ ae("__injectWithOption"), At = /* @__PURE__ */ ae("__dispose");
function we(e) {
  if (!F(e))
    return e;
  for (const t in e)
    if (Ye(e, t))
      if (!t.includes("."))
        F(e[t]) && we(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let a = e, s = !1;
        for (let l = 0; l < r; l++) {
          if (n[l] in a || (a[n[l]] = {}), !F(a[n[l]])) {
            process.env.NODE_ENV !== "production" && fe(Qe(ce.IGNORE_OBJ_FLATTEN, {
              key: n[l]
            })), s = !0;
            break;
          }
          a = a[n[l]];
        }
        s || (a[n[r]] = e[t], delete e[t]), F(a[n[r]]) && we(a[n[r]]);
      }
  return e;
}
function Ut(e, t) {
  const { messages: n, __i18n: r, messageResolver: a, flatJson: s } = t, l = P(n) ? n : W(r) ? {} : { [e]: {} };
  if (W(r) && r.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: u, resource: d } = i;
      u ? (l[u] = l[u] || {}, He(d, l[u])) : He(d, l);
    } else
      T(i) && He(JSON.parse(i), l);
  }), a == null && s)
    for (const i in l)
      Ye(l, i) && we(l[i]);
  return l;
}
function jn(e) {
  return e.type;
}
function Kn(e, t, n) {
  let r = F(t.messages) ? t.messages : {};
  "__i18nGlobal" in n && (r = Ut(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const a = Object.keys(r);
  a.length && a.forEach((s) => {
    e.mergeLocaleMessage(s, r[s]);
  });
  {
    if (F(t.datetimeFormats)) {
      const s = Object.keys(t.datetimeFormats);
      s.length && s.forEach((l) => {
        e.mergeDateTimeFormat(l, t.datetimeFormats[l]);
      });
    }
    if (F(t.numberFormats)) {
      const s = Object.keys(t.numberFormats);
      s.length && s.forEach((l) => {
        e.mergeNumberFormat(l, t.numberFormats[l]);
      });
    }
  }
}
function _n(e) {
  return or(ir, null, e, 0);
}
const mn = "__INTLIFY_META__", dn = () => [], Za = () => !1;
let En = 0;
function gn(e) {
  return (t, n, r, a) => e(n, r, Re() || void 0, a);
}
const es = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = Re();
  let t = null;
  return e && (t = jn(e)[mn]) ? { [mn]: t } : null;
};
function wt(e = {}) {
  const { __root: t, __injectWithOption: n } = e, r = t === void 0, a = e.flatJson, s = ne ? sr : lr;
  let l = M(e.inheritLocale) ? e.inheritLocale : !0;
  const i = s(
    // prettier-ignore
    t && l ? t.locale.value : T(e.locale) ? e.locale : Me
  ), u = s(
    // prettier-ignore
    t && l ? t.fallbackLocale.value : T(e.fallbackLocale) || W(e.fallbackLocale) || P(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), d = s(Ut(i.value, e)), L = s(P(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), h = s(P(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let g = t ? t.missingWarn : M(e.missingWarn) || Oe(e.missingWarn) ? e.missingWarn : !0, A = t ? t.fallbackWarn : M(e.fallbackWarn) || Oe(e.fallbackWarn) ? e.fallbackWarn : !0, y = t ? t.fallbackRoot : M(e.fallbackRoot) ? e.fallbackRoot : !0, C = !!e.fallbackFormat, k = x(e.missing) ? e.missing : null, f = x(e.missing) ? gn(e.missing) : null, _ = x(e.postTranslation) ? e.postTranslation : null, v = t ? t.warnHtmlMessage : M(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, E = !!e.escapeParameter;
  const O = t ? t.modifiers : P(e.modifiers) ? e.modifiers : {};
  let I = e.pluralRules || t && t.pluralRules, p;
  p = (() => {
    r && tn(null);
    const m = {
      version: Ja,
      locale: i.value,
      fallbackLocale: u.value,
      messages: d.value,
      modifiers: O,
      pluralRules: I,
      missing: f === null ? void 0 : f,
      missingWarn: g,
      fallbackWarn: A,
      fallbackFormat: C,
      unresolving: !0,
      postTranslation: _ === null ? void 0 : _,
      warnHtmlMessage: v,
      escapeParameter: E,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    m.datetimeFormats = L.value, m.numberFormats = h.value, m.__datetimeFormatters = P(p) ? p.__datetimeFormatters : void 0, m.__numberFormatters = P(p) ? p.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (m.__v_emitter = P(p) ? p.__v_emitter : void 0);
    const b = Aa(m);
    return r && tn(b), b;
  })(), Pe(p, i.value, u.value);
  function w() {
    return [
      i.value,
      u.value,
      d.value,
      L.value,
      h.value
    ];
  }
  const j = De({
    get: () => i.value,
    set: (m) => {
      i.value = m, p.locale = i.value;
    }
  }), te = De({
    get: () => u.value,
    set: (m) => {
      u.value = m, p.fallbackLocale = u.value, Pe(p, i.value, m);
    }
  }), K = De(() => d.value), he = /* @__PURE__ */ De(() => L.value), qe = /* @__PURE__ */ De(() => h.value);
  function ze() {
    return x(_) ? _ : null;
  }
  function Ze(m) {
    _ = m, p.postTranslation = m;
  }
  function et() {
    return k;
  }
  function tt(m) {
    m !== null && (f = gn(m)), k = m, p.missing = f;
  }
  function nt(m, b) {
    return m !== "translate" || !b.resolvedMessage;
  }
  const se = (m, b, V, Y, de, xe) => {
    w();
    let ve;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (p.fallbackContext = t ? Ia() : void 0), ve = m(p);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (p.fallbackContext = void 0);
    }
    if (V !== "translate exists" && // for not `te` (e.g `t`)
    B(ve) && ve === Xe || V === "translate exists" && !ve) {
      const [Ee, Zn] = b();
      if (process.env.NODE_ENV !== "production" && t && T(Ee) && nt(V, Zn) && (y && (Je(A, Ee) || Mn(g, Ee)) && fe(Qe(ce.FALLBACK_TO_ROOT, {
        key: Ee,
        type: V
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Gt } = p;
        Gt && y && Gt.emit("fallback", {
          type: V,
          key: Ee,
          to: "global",
          groupId: `${V}:${Ee}`
        });
      }
      return t && y ? Y(t) : de(Ee);
    } else {
      if (xe(ve))
        return ve;
      throw q($.UNEXPECTED_RETURN_TYPE);
    }
  };
  function ke(...m) {
    return se((b) => Reflect.apply(fn, null, [b, ...m]), () => vt(...m), "translate", (b) => Reflect.apply(b.t, b, [...m]), (b) => b, (b) => T(b));
  }
  function rt(...m) {
    const [b, V, Y] = m;
    if (Y && !F(Y))
      throw q($.INVALID_ARGUMENT);
    return ke(b, V, X({ resolvedMessage: !0 }, Y || {}));
  }
  function at(...m) {
    return se((b) => Reflect.apply(an, null, [b, ...m]), () => bt(...m), "datetime format", (b) => Reflect.apply(b.d, b, [...m]), () => je, (b) => T(b));
  }
  function st(...m) {
    return se((b) => Reflect.apply(ln, null, [b, ...m]), () => ht(...m), "number format", (b) => Reflect.apply(b.n, b, [...m]), () => je, (b) => T(b));
  }
  function lt(m) {
    return m.map((b) => T(b) || B(b) || M(b) ? _n(String(b)) : b);
  }
  const ot = {
    normalize: lt,
    interpolate: (m) => m,
    type: "vnode"
  };
  function $e(...m) {
    return se((b) => {
      let V;
      const Y = b;
      try {
        Y.processor = ot, V = Reflect.apply(fn, null, [Y, ...m]);
      } finally {
        Y.processor = null;
      }
      return V;
    }, () => vt(...m), "translate", (b) => b[Tt](...m), (b) => [_n(b)], (b) => W(b));
  }
  function it(...m) {
    return se((b) => Reflect.apply(ln, null, [b, ...m]), () => ht(...m), "number format", (b) => b[It](...m), dn, (b) => T(b) || W(b));
  }
  function ct(...m) {
    return se((b) => Reflect.apply(an, null, [b, ...m]), () => bt(...m), "datetime format", (b) => b[Ot](...m), dn, (b) => T(b) || W(b));
  }
  function ut(m) {
    I = m, p.pluralRules = I;
  }
  function ft(m, b) {
    return se(() => {
      if (!m)
        return !1;
      const V = T(b) ? b : i.value, Y = me(V), de = p.messageResolver(Y, m);
      return ue(de) || ee(de) || T(de);
    }, () => [m], "translate exists", (V) => Reflect.apply(V.te, V, [m, b]), Za, (V) => M(V));
  }
  function Ce(m) {
    let b = null;
    const V = Sn(p, u.value, i.value);
    for (let Y = 0; Y < V.length; Y++) {
      const de = d.value[V[Y]] || {}, xe = p.messageResolver(de, m);
      if (xe != null) {
        b = xe;
        break;
      }
    }
    return b;
  }
  function Se(m) {
    const b = Ce(m);
    return b ?? (t ? t.tm(m) || {} : {});
  }
  function me(m) {
    return d.value[m] || {};
  }
  function ye(m, b) {
    if (a) {
      const V = { [m]: b };
      for (const Y in V)
        Ye(V, Y) && we(V[Y]);
      b = V[m];
    }
    d.value[m] = b, p.messages = d.value;
  }
  function _t(m, b) {
    d.value[m] = d.value[m] || {};
    const V = { [m]: b };
    if (a)
      for (const Y in V)
        Ye(V, Y) && we(V[Y]);
    b = V[m], He(b, d.value[m]), p.messages = d.value;
  }
  function o(m) {
    return L.value[m] || {};
  }
  function c(m, b) {
    L.value[m] = b, p.datetimeFormats = L.value, sn(p, m, b);
  }
  function N(m, b) {
    L.value[m] = X(L.value[m] || {}, b), p.datetimeFormats = L.value, sn(p, m, b);
  }
  function S(m) {
    return h.value[m] || {};
  }
  function G(m, b) {
    h.value[m] = b, p.numberFormats = h.value, on(p, m, b);
  }
  function H(m, b) {
    h.value[m] = X(h.value[m] || {}, b), p.numberFormats = h.value, on(p, m, b);
  }
  En++, t && ne && (gt(t.locale, (m) => {
    l && (i.value = m, p.locale = m, Pe(p, i.value, u.value));
  }), gt(t.fallbackLocale, (m) => {
    l && (u.value = m, p.fallbackLocale = m, Pe(p, i.value, u.value));
  }));
  const U = {
    id: En,
    locale: j,
    fallbackLocale: te,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(m) {
      l = m, m && t && (i.value = t.locale.value, u.value = t.fallbackLocale.value, Pe(p, i.value, u.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: K,
    get modifiers() {
      return O;
    },
    get pluralRules() {
      return I || {};
    },
    get isGlobal() {
      return r;
    },
    get missingWarn() {
      return g;
    },
    set missingWarn(m) {
      g = m, p.missingWarn = g;
    },
    get fallbackWarn() {
      return A;
    },
    set fallbackWarn(m) {
      A = m, p.fallbackWarn = A;
    },
    get fallbackRoot() {
      return y;
    },
    set fallbackRoot(m) {
      y = m;
    },
    get fallbackFormat() {
      return C;
    },
    set fallbackFormat(m) {
      C = m, p.fallbackFormat = C;
    },
    get warnHtmlMessage() {
      return v;
    },
    set warnHtmlMessage(m) {
      v = m, p.warnHtmlMessage = m;
    },
    get escapeParameter() {
      return E;
    },
    set escapeParameter(m) {
      E = m, p.escapeParameter = m;
    },
    t: ke,
    getLocaleMessage: me,
    setLocaleMessage: ye,
    mergeLocaleMessage: _t,
    getPostTranslationHandler: ze,
    setPostTranslationHandler: Ze,
    getMissingHandler: et,
    setMissingHandler: tt,
    [Hn]: ut
  };
  return U.datetimeFormats = he, U.numberFormats = qe, U.rt = rt, U.te = ft, U.tm = Se, U.d = at, U.n = st, U.getDateTimeFormat = o, U.setDateTimeFormat = c, U.mergeDateTimeFormat = N, U.getNumberFormat = S, U.setNumberFormat = G, U.mergeNumberFormat = H, U[Yn] = n, U[Tt] = $e, U[Ot] = ct, U[It] = it, process.env.NODE_ENV !== "production" && (U[be] = (m) => {
    p.__v_emitter = m;
  }, U[Ue] = () => {
    p.__v_emitter = void 0;
  }), U;
}
const Bn = "vue-i18n: composer properties", Et = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n DevTools",
  "vue-i18n-resource-inspector": "Vue I18n DevTools",
  "vue-i18n-timeline": "Vue I18n"
}, ts = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, ns = {
  "vue-i18n-timeline": 16764185
};
let kt;
async function rs(e, t) {
  return new Promise((n, r) => {
    try {
      Xa({
        id: "vue-devtools-plugin-vue-i18n",
        label: Et["vue-devtools-plugin-vue-i18n"],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [Bn],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (a) => {
        kt = a, a.on.visitComponentTree(({ componentInstance: l, treeNode: i }) => {
          as(l, i, t);
        }), a.on.inspectComponent(({ componentInstance: l, instanceData: i }) => {
          l.vnode.el && l.vnode.el.__VUE_I18N__ && i && (t.mode === "legacy" ? l.vnode.el.__VUE_I18N__ !== t.global.__composer && pn(i, l.vnode.el.__VUE_I18N__) : pn(i, l.vnode.el.__VUE_I18N__));
        }), a.addInspector({
          id: "vue-i18n-resource-inspector",
          label: Et["vue-i18n-resource-inspector"],
          icon: "language",
          treeFilterPlaceholder: ts["vue-i18n-resource-inspector"]
        }), a.on.getInspectorTree((l) => {
          l.app === e && l.inspectorId === "vue-i18n-resource-inspector" && cs(l, t);
        });
        const s = /* @__PURE__ */ new Map();
        a.on.getInspectorState(async (l) => {
          if (l.app === e && l.inspectorId === "vue-i18n-resource-inspector")
            if (a.unhighlightElement(), fs(l, t), l.nodeId === "global") {
              if (!s.has(l.app)) {
                const [i] = await a.getComponentInstances(l.app);
                s.set(l.app, i);
              }
              a.highlightElement(s.get(l.app));
            } else {
              const i = us(l.nodeId, t);
              i && a.highlightElement(i);
            }
        }), a.on.editInspectorState((l) => {
          l.app === e && l.inspectorId === "vue-i18n-resource-inspector" && ms(l, t);
        }), a.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: Et["vue-i18n-timeline"],
          color: ns["vue-i18n-timeline"]
        }), n(!0);
      });
    } catch (a) {
      console.error(a), r(!1);
    }
  });
}
function Xn(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function as(e, t, n) {
  const r = n.mode === "composition" ? n.global : n.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== r) {
    const a = {
      label: `i18n (${Xn(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(a);
  }
}
function pn(e, t) {
  const n = Bn;
  e.state.push({
    type: n,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: n,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: n,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: n,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: n,
    key: "messages",
    editable: !1,
    value: Vt(t.messages.value)
  }), e.state.push({
    type: n,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: n,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function Vt(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    x(r) && "source" in r ? t[n] = is(r) : ue(r) && r.loc && r.loc.source ? t[n] = r.loc.source : F(r) ? t[n] = Vt(r) : t[n] = r;
  }), t;
}
const ss = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function ls(e) {
  return e.replace(/[<>"&]/g, os);
}
function os(e) {
  return ss[e] || e;
}
function is(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${ls(e.source)}")` : "(?)"}`
    }
  };
}
function cs(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const n = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [r, a] of t.__instances) {
    const s = t.mode === "composition" ? a : a.__composer;
    n !== s && e.rootNodes.push({
      id: s.id.toString(),
      label: `${Xn(r)} Scope`
    });
  }
}
function us(e, t) {
  let n = null;
  if (e !== "global") {
    for (const [r, a] of t.__instances.entries())
      if (a.id.toString() === e) {
        n = r;
        break;
      }
  }
  return n;
}
function Jn(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const n = Array.from(t.__instances.values()).find((r) => r.id.toString() === e);
    return n ? t.mode === "composition" ? n : n.__composer : null;
  }
}
function fs(e, t) {
  const n = Jn(e.nodeId, t);
  return n && (e.state = _s(n)), null;
}
function _s(e) {
  const t = {}, n = "Locale related info", r = [
    {
      type: n,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: n,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: n,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: n,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[n] = r;
  const a = "Locale messages info", s = [
    {
      type: a,
      key: "messages",
      editable: !1,
      value: Vt(e.messages.value)
    }
  ];
  t[a] = s;
  {
    const l = "Datetime formats info", i = [
      {
        type: l,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[l] = i;
    const u = "Datetime formats info", d = [
      {
        type: u,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[u] = d;
  }
  return t;
}
function Ve(e, t) {
  if (kt) {
    let n;
    t && "groupId" in t && (n = t.groupId, delete t.groupId), kt.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: n,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function ms(e, t) {
  const n = Jn(e.nodeId, t);
  if (n) {
    const [r] = e.path;
    r === "locale" && T(e.state.value) ? n.locale.value = e.state.value : r === "fallbackLocale" && (T(e.state.value) || W(e.state.value) || F(e.state.value)) ? n.fallbackLocale.value = e.state.value : r === "inheritLocale" && M(e.state.value) && (n.inheritLocale = e.state.value);
  }
}
function ds(e) {
  const t = T(e.locale) ? e.locale : Me, n = T(e.fallbackLocale) || W(e.fallbackLocale) || P(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : t, r = x(e.missing) ? e.missing : void 0, a = M(e.silentTranslationWarn) || Oe(e.silentTranslationWarn) ? !e.silentTranslationWarn : !0, s = M(e.silentFallbackWarn) || Oe(e.silentFallbackWarn) ? !e.silentFallbackWarn : !0, l = M(e.fallbackRoot) ? e.fallbackRoot : !0, i = !!e.formatFallbackMessages, u = P(e.modifiers) ? e.modifiers : {}, d = e.pluralizationRules, L = x(e.postTranslation) ? e.postTranslation : void 0, h = T(e.warnHtmlInMessage) ? e.warnHtmlInMessage !== "off" : !0, g = !!e.escapeParameterHtml, A = M(e.sync) ? e.sync : !0;
  let y = e.messages;
  if (P(e.sharedMessages)) {
    const O = e.sharedMessages;
    y = Object.keys(O).reduce((p, R) => {
      const w = p[R] || (p[R] = {});
      return X(w, O[R]), p;
    }, y || {});
  }
  const { __i18n: C, __root: k, __injectWithOption: f } = e, _ = e.datetimeFormats, v = e.numberFormats, E = e.flatJson;
  return {
    locale: t,
    fallbackLocale: n,
    messages: y,
    flatJson: E,
    datetimeFormats: _,
    numberFormats: v,
    missing: r,
    missingWarn: a,
    fallbackWarn: s,
    fallbackRoot: l,
    fallbackFormat: i,
    modifiers: u,
    pluralRules: d,
    postTranslation: L,
    warnHtmlMessage: h,
    escapeParameter: g,
    messageResolver: e.messageResolver,
    inheritLocale: A,
    __i18n: C,
    __root: k,
    __injectWithOption: f
  };
}
function Ct(e = {}) {
  const t = wt(ds(e)), { __extender: n } = e, r = {
    // id
    id: t.id,
    // locale
    get locale() {
      return t.locale.value;
    },
    set locale(a) {
      t.locale.value = a;
    },
    // fallbackLocale
    get fallbackLocale() {
      return t.fallbackLocale.value;
    },
    set fallbackLocale(a) {
      t.fallbackLocale.value = a;
    },
    // messages
    get messages() {
      return t.messages.value;
    },
    // datetimeFormats
    get datetimeFormats() {
      return t.datetimeFormats.value;
    },
    // numberFormats
    get numberFormats() {
      return t.numberFormats.value;
    },
    // availableLocales
    get availableLocales() {
      return t.availableLocales;
    },
    // missing
    get missing() {
      return t.getMissingHandler();
    },
    set missing(a) {
      t.setMissingHandler(a);
    },
    // silentTranslationWarn
    get silentTranslationWarn() {
      return M(t.missingWarn) ? !t.missingWarn : t.missingWarn;
    },
    set silentTranslationWarn(a) {
      t.missingWarn = M(a) ? !a : a;
    },
    // silentFallbackWarn
    get silentFallbackWarn() {
      return M(t.fallbackWarn) ? !t.fallbackWarn : t.fallbackWarn;
    },
    set silentFallbackWarn(a) {
      t.fallbackWarn = M(a) ? !a : a;
    },
    // modifiers
    get modifiers() {
      return t.modifiers;
    },
    // formatFallbackMessages
    get formatFallbackMessages() {
      return t.fallbackFormat;
    },
    set formatFallbackMessages(a) {
      t.fallbackFormat = a;
    },
    // postTranslation
    get postTranslation() {
      return t.getPostTranslationHandler();
    },
    set postTranslation(a) {
      t.setPostTranslationHandler(a);
    },
    // sync
    get sync() {
      return t.inheritLocale;
    },
    set sync(a) {
      t.inheritLocale = a;
    },
    // warnInHtmlMessage
    get warnHtmlInMessage() {
      return t.warnHtmlMessage ? "warn" : "off";
    },
    set warnHtmlInMessage(a) {
      t.warnHtmlMessage = a !== "off";
    },
    // escapeParameterHtml
    get escapeParameterHtml() {
      return t.escapeParameter;
    },
    set escapeParameterHtml(a) {
      t.escapeParameter = a;
    },
    // pluralizationRules
    get pluralizationRules() {
      return t.pluralRules || {};
    },
    // for internal
    __composer: t,
    // t
    t(...a) {
      return Reflect.apply(t.t, t, [...a]);
    },
    // rt
    rt(...a) {
      return Reflect.apply(t.rt, t, [...a]);
    },
    // tc
    tc(...a) {
      const [s, l, i] = a, u = { plural: 1 };
      let d = null, L = null;
      if (process.env.NODE_ENV !== "production" && Cn(Qe(ce.DEPRECATE_TC)), !T(s))
        throw q($.INVALID_ARGUMENT);
      const h = s;
      return T(l) ? u.locale = l : B(l) ? u.plural = l : W(l) ? d = l : P(l) && (L = l), T(i) ? u.locale = i : W(i) ? d = i : P(i) && (L = i), Reflect.apply(t.t, t, [
        h,
        d || L || {},
        u
      ]);
    },
    // te
    te(a, s) {
      return t.te(a, s);
    },
    // tm
    tm(a) {
      return t.tm(a);
    },
    // getLocaleMessage
    getLocaleMessage(a) {
      return t.getLocaleMessage(a);
    },
    // setLocaleMessage
    setLocaleMessage(a, s) {
      t.setLocaleMessage(a, s);
    },
    // mergeLocaleMessage
    mergeLocaleMessage(a, s) {
      t.mergeLocaleMessage(a, s);
    },
    // d
    d(...a) {
      return Reflect.apply(t.d, t, [...a]);
    },
    // getDateTimeFormat
    getDateTimeFormat(a) {
      return t.getDateTimeFormat(a);
    },
    // setDateTimeFormat
    setDateTimeFormat(a, s) {
      t.setDateTimeFormat(a, s);
    },
    // mergeDateTimeFormat
    mergeDateTimeFormat(a, s) {
      t.mergeDateTimeFormat(a, s);
    },
    // n
    n(...a) {
      return Reflect.apply(t.n, t, [...a]);
    },
    // getNumberFormat
    getNumberFormat(a) {
      return t.getNumberFormat(a);
    },
    // setNumberFormat
    setNumberFormat(a, s) {
      t.setNumberFormat(a, s);
    },
    // mergeNumberFormat
    mergeNumberFormat(a, s) {
      t.mergeNumberFormat(a, s);
    }
  };
  return r.__extender = n, process.env.NODE_ENV !== "production" && (r.__enableEmitter = (a) => {
    const s = t;
    s[be] && s[be](a);
  }, r.__disableEmitter = () => {
    const a = t;
    a[Ue] && a[Ue]();
  }), r;
}
function Es(e, t, n) {
  return {
    beforeCreate() {
      const r = Re();
      if (!r)
        throw q($.UNEXPECTED_ERROR);
      const a = this.$options;
      if (a.i18n) {
        const s = a.i18n;
        if (a.__i18n && (s.__i18n = a.__i18n), s.__root = t, this === this.$root)
          this.$i18n = Nn(e, s);
        else {
          s.__injectWithOption = !0, s.__extender = n.__vueI18nExtend, this.$i18n = Ct(s);
          const l = this.$i18n;
          l.__extender && (l.__disposer = l.__extender(this.$i18n));
        }
      } else if (a.__i18n)
        if (this === this.$root)
          this.$i18n = Nn(e, a);
        else {
          this.$i18n = Ct({
            __i18n: a.__i18n,
            __injectWithOption: !0,
            __extender: n.__vueI18nExtend,
            __root: t
          });
          const s = this.$i18n;
          s.__extender && (s.__disposer = s.__extender(this.$i18n));
        }
      else
        this.$i18n = e;
      a.__i18nGlobal && Kn(t, a, a), this.$t = (...s) => this.$i18n.t(...s), this.$rt = (...s) => this.$i18n.rt(...s), this.$tc = (...s) => this.$i18n.tc(...s), this.$te = (s, l) => this.$i18n.te(s, l), this.$d = (...s) => this.$i18n.d(...s), this.$n = (...s) => this.$i18n.n(...s), this.$tm = (s) => this.$i18n.tm(s), n.__setInstance(r, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const r = this.$i18n;
        this.$el.__VUE_I18N__ = r.__composer;
        const a = this.__v_emitter = Pt();
        r.__enableEmitter && r.__enableEmitter(a), a.on("*", Ve);
      }
    },
    unmounted() {
      const r = Re();
      if (!r)
        throw q($.UNEXPECTED_ERROR);
      const a = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", Ve), delete this.__v_emitter), this.$i18n && (a.__disableEmitter && a.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$tc, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, a.__disposer && (a.__disposer(), delete a.__disposer, delete a.__extender), n.__deleteInstance(r), delete this.$i18n;
    }
  };
}
function Nn(e, t) {
  e.locale = t.locale || e.locale, e.fallbackLocale = t.fallbackLocale || e.fallbackLocale, e.missing = t.missing || e.missing, e.silentTranslationWarn = t.silentTranslationWarn || e.silentFallbackWarn, e.silentFallbackWarn = t.silentFallbackWarn || e.silentFallbackWarn, e.formatFallbackMessages = t.formatFallbackMessages || e.formatFallbackMessages, e.postTranslation = t.postTranslation || e.postTranslation, e.warnHtmlInMessage = t.warnHtmlInMessage || e.warnHtmlInMessage, e.escapeParameterHtml = t.escapeParameterHtml || e.escapeParameterHtml, e.sync = t.sync || e.sync, e.__composer[Hn](t.pluralizationRules || e.pluralizationRules);
  const n = Ut(e.locale, {
    messages: t.messages,
    __i18n: t.__i18n
  });
  return Object.keys(n).forEach((r) => e.mergeLocaleMessage(r, n[r])), t.datetimeFormats && Object.keys(t.datetimeFormats).forEach((r) => e.mergeDateTimeFormat(r, t.datetimeFormats[r])), t.numberFormats && Object.keys(t.numberFormats).forEach((r) => e.mergeNumberFormat(r, t.numberFormats[r])), e;
}
const $t = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function gs({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, a) => [
    ...r,
    // prettier-ignore
    ...a.type === An ? a.children : [a]
  ], []) : t.reduce((n, r) => {
    const a = e[r];
    return a && (n[r] = a()), n;
  }, {});
}
function Qn() {
  return An;
}
const ps = /* @__PURE__ */ St({
  /* eslint-disable */
  name: "i18n-t",
  props: X({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      validator: (e) => B(e) || !isNaN(e)
    }
  }, $t),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: n, attrs: r } = t, a = e.i18n || xt({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const s = Object.keys(n).filter((h) => h !== "_"), l = {};
      e.locale && (l.locale = e.locale), e.plural !== void 0 && (l.plural = T(e.plural) ? +e.plural : e.plural);
      const i = gs(t, s), u = a[Tt](e.keypath, i, l), d = X({}, r), L = T(e.tag) || F(e.tag) ? e.tag : Qn();
      return In(L, d, u);
    };
  }
}), bn = ps;
function Ns(e) {
  return W(e) && !T(e[0]);
}
function qn(e, t, n, r) {
  const { slots: a, attrs: s } = t;
  return () => {
    const l = { part: !0 };
    let i = {};
    e.locale && (l.locale = e.locale), T(e.format) ? l.key = e.format : F(e.format) && (T(e.format.key) && (l.key = e.format.key), i = Object.keys(e.format).reduce((g, A) => n.includes(A) ? X({}, g, { [A]: e.format[A] }) : g, {}));
    const u = r(e.value, l, i);
    let d = [l.key];
    W(u) ? d = u.map((g, A) => {
      const y = a[g.type], C = y ? y({ [g.type]: g.value, index: A, parts: u }) : [g.value];
      return Ns(C) && (C[0].key = `${g.type}-${A}`), C;
    }) : T(u) && (d = [u]);
    const L = X({}, s), h = T(e.tag) || F(e.tag) ? e.tag : Qn();
    return In(h, L, d);
  };
}
const bs = /* @__PURE__ */ St({
  /* eslint-disable */
  name: "i18n-n",
  props: X({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, $t),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || xt({
      useScope: e.scope,
      __useComponent: !0
    });
    return qn(e, t, $n, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[It](...r)
    ));
  }
}), hn = bs, hs = /* @__PURE__ */ St({
  /* eslint-disable */
  name: "i18n-d",
  props: X({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, $t),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || xt({
      useScope: e.scope,
      __useComponent: !0
    });
    return qn(e, t, Vn, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[Ot](...r)
    ));
  }
}), vn = hs;
function vs(e, t) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(t) || e.global;
  {
    const r = n.__getInstance(t);
    return r != null ? r.__composer : e.global.__composer;
  }
}
function Ls(e) {
  const t = (l) => {
    const { instance: i, value: u } = l;
    if (!i || !i.$)
      throw q($.UNEXPECTED_ERROR);
    const d = vs(e, i.$), L = Ln(u);
    return [
      Reflect.apply(d.t, d, [...Tn(L)]),
      d
    ];
  };
  return {
    created: (l, i) => {
      const [u, d] = t(i);
      ne && e.global === d && (l.__i18nWatcher = gt(d.locale, () => {
        i.instance && i.instance.$forceUpdate();
      })), l.__composer = d, l.textContent = u;
    },
    unmounted: (l) => {
      ne && l.__i18nWatcher && (l.__i18nWatcher(), l.__i18nWatcher = void 0, delete l.__i18nWatcher), l.__composer && (l.__composer = void 0, delete l.__composer);
    },
    beforeUpdate: (l, { value: i }) => {
      if (l.__composer) {
        const u = l.__composer, d = Ln(i);
        l.textContent = Reflect.apply(u.t, u, [
          ...Tn(d)
        ]);
      }
    },
    getSSRProps: (l) => {
      const [i] = t(l);
      return { textContent: i };
    }
  };
}
function Ln(e) {
  if (T(e))
    return { path: e };
  if (P(e)) {
    if (!("path" in e))
      throw q($.REQUIRED_VALUE, "path");
    return e;
  } else
    throw q($.INVALID_VALUE);
}
function Tn(e) {
  const { path: t, locale: n, args: r, choice: a, plural: s } = e, l = {}, i = r || {};
  return T(n) && (l.locale = n), B(a) && (l.plural = a), B(s) && (l.plural = s), [t, i, l];
}
function Ts(e, t, ...n) {
  const r = P(n[0]) ? n[0] : {};
  (M(r.globalInstall) ? r.globalInstall : !0) && ([bn.name, "I18nT"].forEach((s) => e.component(s, bn)), [hn.name, "I18nN"].forEach((s) => e.component(s, hn)), [vn.name, "I18nD"].forEach((s) => e.component(s, vn))), e.directive("t", Ls(t));
}
const Os = /* @__PURE__ */ ae("global-vue-i18n");
function Is(e = {}, t) {
  const n = __VUE_I18N_LEGACY_API__ && M(e.legacy) ? e.legacy : __VUE_I18N_LEGACY_API__, r = M(e.globalInjection) ? e.globalInjection : !0, a = /* @__PURE__ */ new Map(), [s, l] = As(e, n), i = /* @__PURE__ */ ae(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  function u(g) {
    return a.get(g) || null;
  }
  function d(g, A) {
    a.set(g, A);
  }
  function L(g) {
    a.delete(g);
  }
  const h = {
    // mode
    get mode() {
      return __VUE_I18N_LEGACY_API__ && n ? "legacy" : "composition";
    },
    // install plugin
    async install(g, ...A) {
      if (process.env.NODE_ENV !== "production" && (g.__VUE_I18N__ = h), g.__VUE_I18N_SYMBOL__ = i, g.provide(g.__VUE_I18N_SYMBOL__, h), P(A[0])) {
        const k = A[0];
        h.__composerExtend = k.__composerExtend, h.__vueI18nExtend = k.__vueI18nExtend;
      }
      let y = null;
      !n && r && (y = Fs(g, h.global)), __VUE_I18N_FULL_INSTALL__ && Ts(g, h, ...A), __VUE_I18N_LEGACY_API__ && n && g.mixin(Es(l, l.__composer, h));
      const C = g.unmount;
      if (g.unmount = () => {
        y && y(), h.dispose(), C();
      }, process.env.NODE_ENV !== "production") {
        if (!await rs(g, h))
          throw q($.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
        const f = Pt();
        if (n) {
          const _ = l;
          _.__enableEmitter && _.__enableEmitter(f);
        } else {
          const _ = l;
          _[be] && _[be](f);
        }
        f.on("*", Ve);
      }
    },
    // global accessor
    get global() {
      return l;
    },
    dispose() {
      s.stop();
    },
    // @internal
    __instances: a,
    // @internal
    __getInstance: u,
    // @internal
    __setInstance: d,
    // @internal
    __deleteInstance: L
  };
  return h;
}
function xt(e = {}) {
  const t = Re();
  if (t == null)
    throw q($.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw q($.NOT_INSTALLED);
  const n = ks(t), r = Ss(n), a = jn(t), s = Cs(e, a);
  if (s === "global")
    return Kn(r, e, a), r;
  if (s === "parent") {
    let u = ys(n, t, e.__useComponent);
    return u == null && (process.env.NODE_ENV !== "production" && fe(Qe(ce.NOT_FOUND_PARENT_SCOPE)), u = r), u;
  }
  const l = n;
  let i = l.__getInstance(t);
  if (i == null) {
    const u = X({}, e);
    "__i18n" in a && (u.__i18n = a.__i18n), r && (u.__root = r), i = wt(u), l.__composerExtend && (i[At] = l.__composerExtend(i)), Ps(l, t, i), l.__setInstance(t, i);
  }
  return i;
}
function As(e, t, n) {
  const r = er(), a = __VUE_I18N_LEGACY_API__ && t ? r.run(() => Ct(e)) : r.run(() => wt(e));
  if (a == null)
    throw q($.UNEXPECTED_ERROR);
  return [r, a];
}
function ks(e) {
  const t = tr(e.isCE ? Os : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw q(e.isCE ? $.NOT_INSTALLED_WITH_PROVIDE : $.UNEXPECTED_ERROR);
  return t;
}
function Cs(e, t) {
  return Be(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Ss(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function ys(e, t, n = !1) {
  let r = null;
  const a = t.root;
  let s = Ds(t, n);
  for (; s != null; ) {
    const l = e;
    if (e.mode === "composition")
      r = l.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = l.__getInstance(s);
      i != null && (r = i.__composer, n && r && !r[Yn] && (r = null));
    }
    if (r != null || a === s)
      break;
    s = s.parent;
  }
  return r;
}
function Ds(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Ps(e, t, n) {
  let r = null;
  nr(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, r = Pt();
      const a = n;
      a[be] && a[be](r), r.on("*", Ve);
    }
  }, t), rr(() => {
    const a = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (r && r.off("*", Ve), a[Ue] && a[Ue](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const s = a[At];
    s && (s(), delete a[At]);
  }, t);
}
const Rs = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], On = ["t", "rt", "d", "n", "tm", "te"];
function Fs(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  return Rs.forEach((a) => {
    const s = Object.getOwnPropertyDescriptor(t, a);
    if (!s)
      throw q($.UNEXPECTED_ERROR);
    const l = ar(s.value) ? {
      get() {
        return s.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(i) {
        s.value.value = i;
      }
    } : {
      get() {
        return s.get && s.get();
      }
    };
    Object.defineProperty(n, a, l);
  }), e.config.globalProperties.$i18n = n, On.forEach((a) => {
    const s = Object.getOwnPropertyDescriptor(t, a);
    if (!s || !s.value)
      throw q($.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${a}`, s);
  }), () => {
    delete e.config.globalProperties.$i18n, On.forEach((a) => {
      delete e.config.globalProperties[`$${a}`];
    });
  };
}
Qa();
ha(zr);
va(Ea);
La(Sn);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = ge();
  e.__INTLIFY__ = !0, Zr(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Ms = {
  "engrave.content.text": "Treść graweru",
  "engrave.description": "Aby dodać znak do tekstu, zaznacz miejsce, w którym powinien się pojawić i kliknij na ikonę.",
  "engrave.font.cursive": "Odręczna",
  "engrave.font.default": "Domyślna",
  "engrave.font.label": "Czcionka",
  "engrave.font.ornamental": "Ozdobna",
  "global.expand": "rozwiń",
  "global.select.placeholder": "Wybierz"
}, Us = {
  "engrave.content.text": "Engraving content",
  "engrave.description": "To add a character to the text, select the place where it should appear and click on the icon.",
  "engrave.font.cursive": "Handwritten",
  "engrave.font.default": "Default",
  "engrave.font.label": "Font",
  "engrave.font.ornamental": "Decorative",
  "global.expand": "expand",
  "global.select.placeholder": "Select"
}, ws = {
  "engrave.content.text": "Text rytiny",
  "engrave.description": "Pro dodání speciálních znaků označte místo, kde si přejete znak doplnit a zvolte vybrané emoji. ",
  "engrave.font.cursive": "Ruční písmo",
  "engrave.font.default": "Jednoduchý",
  "engrave.font.label": "Font písma",
  "engrave.font.ornamental": "Ozdobný",
  "global.expand": "Rozvinout",
  "global.select.placeholder": "Vybrat"
}, Vs = {
  "engrave.content.text": "Съдържание на гравюрата",
  "engrave.description": "За да добавите знак към текста, маркирайте мястото, където трябва да се появи, и щракнете върху иконата.",
  "engrave.font.cursive": "Ръкописен текст",
  "engrave.font.default": "По подразбиране",
  "engrave.font.label": "Шрифт",
  "engrave.font.ornamental": "Украшение",
  "global.expand": "разгъни",
  "global.select.placeholder": "Избери"
}, $s = {
  "engrave.content.text": "Text gravírovania",
  "engrave.description": "Ak chcete pridať špeciálne znaky, vyberte miesto, kam chcete znak pridať, a vyberte požadovaný emoji. ",
  "engrave.font.cursive": "Ručné písmo",
  "engrave.font.default": "Obyčajný",
  "engrave.font.label": "Font písma",
  "engrave.font.ornamental": "Ozdobný",
  "global.expand": "Rozbaliť",
  "global.select.placeholder": "Vybrať"
}, xs = {
  "engrave.content.text": "Gravurinhalt",
  "engrave.description": "Um ein Zeichen zum Text hinzuzufügen, markiere die Stelle, an der es erscheinen soll, und klicke auf das Symbol.",
  "engrave.font.cursive": "Handschrift",
  "engrave.font.default": "Standard",
  "engrave.font.label": "Schriftart",
  "engrave.font.ornamental": "Dekorativ",
  "global.expand": "erweitern",
  "global.select.placeholder": "Auswählen"
}, Ws = {
  "engrave.content.text": "Gravírozás tartalma",
  "engrave.description": "Ha jelet szeretne hozzáadni a szöveghez, jelölje ki a helyet, ahol meg kell jelennie, és kattintson az ikonra.",
  "engrave.font.cursive": "Kézzel írt",
  "engrave.font.default": "Alapértelmezett",
  "engrave.font.label": "Betűtípus",
  "engrave.font.ornamental": "Dekoratív",
  "global.expand": "kibontás",
  "global.select.placeholder": "Válasszon"
}, Gs = {
  "engrave.content.text": "Conținut gravură",
  "engrave.description": "Pentru a adăuga un caracter în text, selectează locul unde ar trebui să apară și fă clic pe pictogramă.",
  "engrave.font.cursive": "Manuală",
  "engrave.font.default": "Implicită",
  "engrave.font.label": "Font",
  "engrave.font.ornamental": "Decorative",
  "global.expand": "extinde",
  "global.select.placeholder": "Selectează"
}, Hs = {
  "engrave.content.text": "Sadržaj gravure",
  "engrave.description": "Da biste dodali znak u tekst, označite mjesto na kojem bi se trebao pojaviti i kliknite na ikonu.",
  "engrave.font.cursive": "Rukopisna",
  "engrave.font.default": "Zadano",
  "engrave.font.label": "Font",
  "engrave.font.ornamental": "Ukrasna",
  "global.expand": "proširi",
  "global.select.placeholder": "Odaberi"
}, Ys = {
  "engrave.content.text": "Engraving content",
  "engrave.description": "To add a character to the text, select the place where it should appear and click on the icon.",
  "engrave.font.cursive": "Handwritten",
  "engrave.font.default": "Default",
  "engrave.font.label": "Font",
  "engrave.font.ornamental": "Decorative",
  "global.expand": "expand",
  "global.select.placeholder": "Select"
}, js = {
  "engrave.content.text": "Текст гравіювання",
  "engrave.description": "Щоб додати символ до тексту, виберіть місце, де він має з'явитися, і натисніть на іконку.",
  "engrave.font.cursive": "Написано від руки",
  "engrave.font.default": "За замовчуванням",
  "engrave.font.label": "Шрифт",
  "engrave.font.ornamental": "Декоративна",
  "global.expand": "розгорнути",
  "global.select.placeholder": "Виберіть"
}, Ks = {
  "engrave.content.text": "Περιεχόμενο χάραξης",
  "engrave.description": "Για να προσθέσετε ένα χαρακτήρα στο κείμενο, επιλέξτε το σημείο όπου πρέπει να εμφανιστεί και κάντε κλικ στο εικονίδιο.",
  "engrave.font.cursive": "Χειρόγραφα",
  "engrave.font.default": "Προεπιλογή",
  "engrave.font.label": "Γραμματοσειρά",
  "engrave.font.ornamental": "Διακοσμητική",
  "global.expand": "επέκταση",
  "global.select.placeholder": "Επιλέξτε"
}, zn = Is({
  legacy: !1,
  locale: "en",
  // default locale
  fallbackLocale: "en",
  messages: {
    pl: Ms,
    en: Us,
    cs: ws,
    bg: Vs,
    sk: $s,
    de: xs,
    hu: Ws,
    ro: Gs,
    hr: Hs,
    enGb: Ys,
    uk: js,
    el: Ks
  }
});
function Xs() {
  return zn;
}
function Js(e) {
  zn.global.locale.value = e;
}
export {
  Js as setLibraryLocale,
  Xs as useLibraryI18n
};
